import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DeleteUsersBBDDService } from 'src/app/services/delete-users-bbdd.service';

@Component({
  standalone: false,
  selector: 'app-user-sing-in',
  templateUrl: './user-sing-in.component.html',
  styleUrls: ['./user-sing-in.component.scss']
})
export class UserSingInComponent implements OnInit {

  message: string;
  sendId: UntypedFormGroup;

  constructor(private f: UntypedFormBuilder, private ds: DeleteUsersBBDDService) { }

  ngOnInit() {
    this.createForm();
  }

  createForm = () => {
    this.sendId = this.f.group({
      guid: new UntypedFormControl('', [Validators.required])
    }, {});
  }

  deleteUsers = () => {
    this.message = '';
    this.ds.deleteUser(this.sendId.get('guid').value).subscribe(d => {
      this.message = d.Message + ' Codigo: ' + d.Code;
    });
  }

}
